import React, { Component } from 'react';
import {
  Button, Modal, ModalBody,
  FormGroup,
  Input,
  Row, Col,
  Badge,
  Card, CardBody, Table
} from 'reactstrap';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import lodash from 'lodash'; // library added for debounce functionality
import Sidebar from 'react-sidebar';
import NewFleetDetail from '../../components/NewFleetDetail/NewFleetDetail';
import NewFleetService from '../../services/NewFleetService';
import Moment from 'react-moment';
import Pagination from '../../components/Pagination/Pagination';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
// import FleetRegistration from '../../components/FleetRegistration/FleetRegistration';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import AddEditSubsidiaries from '../../components/AddEditSubsidiaries/AddEditSubsidiaries';
import Storage from '../../services/Storage';
import Validation from '../../services/Validation';
import InviteFleet from '../../components/InviteFleet/InviteFleet';
import AddEditFleetVehicle from '../../components/AddEditFleetVehicle/AddEditFleetVehicle';
import { Roles } from '../../constants/constant.role';
class NewFleetRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetail: Storage.getUserDetail(),
      temp_id: null,
      sidebarOpen: false,
      isOpen: false,
      newFleets: [],
      page: 1,
      pageSize: 10,
      totalPages: 0,
      totalElement: 0,
      isLoading: true,
      fleetByIdData: {},
      showBuildMyFleet: false,
      isFleeData: false,
      isListSubsidiaries: false,
      isNoDataFoundNewFleets: false,
      isDisplaySubsidiariesConfirmModal: true,
      isFirstTimeLoadNewFleetsData: false,
      subsidiaresSidebarOpen: false,
      inviteFLeetSidebarOpen: false,
      isAddSubsidiaries: true,
      displaySubsidieryDetail: false,
      editSubsidiariesIndex: 0,
      addEditVehicleType: "truck",
      displayBuildMyFleet: false,
      isOpenViewRemarks: false,
      remark_history: [],
      controls: {
        invite_fleet_mobile_number: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        truck: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        bus: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        scv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        lcv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        q: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        }
      },
      addEditSubsidiaries: [],
      fleetData: {}
    }
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.onSetSidebarOpenSubsidiries = this.onSetSidebarOpenSubsidiries.bind(this);
    this.childNewFleetDetail = React.createRef();
    //this.childInviteFleet = React.createRef();
    this.getNewFleets = lodash.debounce(this.getNewFleets, 500);
  }

  componentDidMount() {
    this.getNewFleets();
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  onSetSidebarOpenInviteFleet = (open) => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    this.setState((prevState) => {
      return { ...prevState, inviteFLeetSidebarOpen: open };
    });
  }


  onSetSidebarOpen(open) {
    document.body.style.overflow = 'hidden';
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: open };
    });

    // setTimeout(() => {
    //   if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
    //     this.refs.childAddEditSubsidiaries.setValue();
    //   }
    // }, 1);
  }

  openSidebarFleetDetail = () => {
    this.onSetSidebarOpen(true);
  }

  onCloseSidebar = () => {
    document.body.style.overflow = 'auto';
    //    this.getSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: false };
    });
  }


  onCloseSidebarSubsidiery = () => {
    //document.body.style.overflow = 'auto';
    this.getSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, subsidiaresSidebarOpen: false };
    });
  }

  searchFleets = () => {

  }

  getNewFleetsById = (id, custom_status) => {
    this.setState({
      isLoading: true
    })
    NewFleetService.getNewFleetById(id)
      .then(res => {
        let { fleetByIdData } = this.state;
        if (res.data.data) {
          fleetByIdData = res.data.data;
          this.setState({
            temp_id: fleetByIdData.uuid,
            fleetByIdData,
            isLoading: false,
            custom_status: custom_status
          });
          setTimeout(() => {
            if (this.childNewFleetDetail.current) {
              this.childNewFleetDetail.current.setFleetData();
              this.getSubsidiaries();
            }
          }, 500);
          if (Object.keys(res.data.data).length > 0) {
            this.openSidebarFleetDetail();
          }
        } else {
          this.setState({
            fleetByIdData: {},
            isLoading: false
          })
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        })
      });
  }

  getNewFleets = () => {
    this.setState({
      isLoading: true
    })
    let { controls } = this.state;
    const reqData = {
      page: this.state.page,
      pageSize: this.state.pageSize,
      q: controls.q.value ? controls.q.value : ""
    }
    NewFleetService.getNewFleet(reqData)
      .then(res => {
        let { newFleets, totalPages, totalElement } = this.state;
        if (res.data.data.data && res.data.data.data.length > 0) {
          newFleets = res.data.data.data;
          totalElement = res.data.data.totalElement;
          totalPages = Math.ceil(totalElement / this.state.pageSize);
          this.setState({
            newFleets,
            totalPages,
            totalElement,
            isLoading: false,
            isNoDataFoundNewFleets: true,
            isFirstTimeLoadNewFleetsData: true
          })
        } else {
          newFleets = [];
          let isNoDataFoundNewFleets = false;
          if (this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE) {
            isNoDataFoundNewFleets = true;
          }
          this.setState({
            newFleets,
            isLoading: false,
            totalElement: 0,
            isNoDataFoundNewFleets: isNoDataFoundNewFleets
          })
        }
      })
      .catch(e => {
        let isNoDataFoundNewFleets = false;
        if (this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE) {
          isNoDataFoundNewFleets = true;
        }
        this.setState({
          isLoading: false,
          totalElement: 0,
          newFleets: [],
          isNoDataFoundNewFleets: isNoDataFoundNewFleets
        })
      });
  }


  handlePageChange = (page) => {
    this.setState({ page });
    setTimeout(() => {
      this.getNewFleets();
    }, 1);
  }


  dynamicAddEditSubsidiaries = () => {
    let { addEditSubsidiaries } = this.state;
    addEditSubsidiaries.push(
      Object.assign({}, {
        controls: {
          id: '',
          uuid: '',
          pin_code: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'pin_code'
          },
          sap_id: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'sap_id'
          },
          subsidiaryName: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'subsidiaryName'
          },
          address1: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_1'
          },
          address2: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_2'
          },
          state: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'state_id'
          },
          city: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'city_id'
          },
          gst: {
            value: '',
            valid: true,
            touched: false,
            required: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'gst_number'
          },
          pan: {
            value: '',
            valid: true,
            required: false,
            touched: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'pan_number'
          }
        },
        isValidForm: false
      })
    );
    this.setState({
      addEditSubsidiaries
    })
  }

  onSetSidebarOpenSubsidiries = (open) => {
    document.body.style.overflow = 'hidden';
    this.dynamicAddEditSubsidiaries();
    this.setState((prevState) => {
      return {
        ...prevState,
        isDisplaySubsidiariesConfirmModal: true,
        subsidiaresSidebarOpen: open,
        isAddSubsidiaries: true,
        editSubsidiariesIndex: this.state.addEditSubsidiaries.length - 1
      };
    });
    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setValue();
      }
    }, 1);
  }
  getSubsidiaries = () => {
    AddEditSubsidiariesService.getSubsidiaries(this.state.temp_id)
      .then(response => {
        let isDisplayedSubsidiariesConfirmModal = false;
        if (response.data && response.data.data && response.data.data.length > 0) {
          let { addEditSubsidiaries } = this.state;
          addEditSubsidiaries = [];
          response.data.data.forEach(element => {
            addEditSubsidiaries.push(
              Object.assign({}, {
                controls: {
                  id: '',
                  uuid: '',
                  pin_code: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'pin_code'
                  },
                  sap_id: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'sap_id'
                  },
                  subsidiaryName: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'subsidiaryName'
                  },
                  address1: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'address_1'
                  },
                  address2: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'address_2'
                  },
                  state: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'state_id'
                  },
                  city: {
                    value: '',
                    valid: null,
                    touched: false,
                    message: null,
                    nullValue: null,
                    invalidFirstname: null,
                    databaseFieldName: 'city_id'
                  },
                  gst: {
                    value: '',
                    valid: true,
                    touched: false,
                    required: false,
                    invalidLength: null,
                    showErrorMsg: false,
                    databaseFieldName: 'gst_number'
                  },
                  pan: {
                    value: '',
                    valid: true,
                    required: false,
                    touched: false,
                    invalidLength: null,
                    showErrorMsg: false,
                    databaseFieldName: 'pan_number'
                  }
                },
                isValidForm: false
              })
            );
          });
          response.data.data.forEach((element, i) => {
            addEditSubsidiaries[i].controls.sap_id.value = element.sap_id;
            addEditSubsidiaries[i].controls.address1.value = element.address_1;
            addEditSubsidiaries[i].controls.address2.value = element.address_2;
            addEditSubsidiaries[i].controls.city.value = element.city_name;
            addEditSubsidiaries[i].controls.gst.value = element.gst_number;
            addEditSubsidiaries[i].controls.pan.value = element.pan_number;
            addEditSubsidiaries[i].controls.state.value = element.state_name;
            addEditSubsidiaries[i].controls.subsidiaryName.value = element.subsidiary_name;
            addEditSubsidiaries[i].controls.id = element.id;
            addEditSubsidiaries[i].controls.uuid = element.uuid;
            addEditSubsidiaries[i].controls.pin_code.value = element.pin_code;
          });
          this.setState({ isListSubsidiaries: true, addEditSubsidiaries });
        } else {
          this.setState({ isListSubsidiaries: false, });
        }
        this.setState(prevState => ({
          ...prevState,
          isDisplayedSubsidiariesConfirmModal
        }));
      })
      .catch(e => {
        console.error('e', e);
      });
  }

  buildMyFleetClick = (flag) => {
    if (!flag) {
      document.body.style.overflow = 'hidden';
      this.getFleetData();
    } else {
      document.body.style.overflow = 'auto';
    }
    this.setState({ showBuildMyFleet: flag });
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    if (controlName === 'q') {
      this.setState({ page: 1 });
      this.getNewFleets();
    }
  }


  updateTruckBusData = (params) => {
    const { controls } = this.state;
    const { truck, bus } = controls;
    truck.value = params.truck.value;
    bus.value = params.bus.value;
    this.setState({ controls });
  }


  addSubsidiaries = () => {
    this.getSubsidiaries();
    this.onCloseSidebarSubsidiery();
  }

  handleInputChangeInviteFleet = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    if (!isNaN(e.target.value)) {
      controls[controlName].value = controlValue;
    }
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidationInviteFleet(false);
  }


  handleValidationInviteFleet = (isSubmit = false) => {

    let { controls } = this.state;
    let { invite_fleet_mobile_number } = controls;

    if (invite_fleet_mobile_number.touched === true || isSubmit) {
      invite_fleet_mobile_number = Validation.notNullValidator(invite_fleet_mobile_number);
      invite_fleet_mobile_number = Validation.validatePhoneNumber(invite_fleet_mobile_number);
      invite_fleet_mobile_number = Validation.validateLength(invite_fleet_mobile_number, 10);
      invite_fleet_mobile_number.valid = !(invite_fleet_mobile_number.invalidPhone || invite_fleet_mobile_number.nullValue || invite_fleet_mobile_number.invalidLength);
      if (invite_fleet_mobile_number.valid === false) {
        invite_fleet_mobile_number.showErrorMsg = true;
      } else {
        invite_fleet_mobile_number.showErrorMsg = false;
      }
    }
    let isFormValid = false;
    if (invite_fleet_mobile_number.valid === true) {
      isFormValid = true;
    }
    this.setState({ controls });
    return isFormValid;
  }


  redirectToEnrollFleet = (id = null) => {
    if (id) {
      this.props.history.push(`/enroll-new-fleet?id=${id}`);
    } else {
      this.props.history.push('/enroll-new-fleet');
    }
  }

  isDataLoding = (flag) => {
    this.setState({
      isLoading: flag
    })
  }

  editSubsidiaries = (index, display = false) => {
    this.setState((prevState) => {
      return {
        ...prevState, subsidiaresSidebarOpen: true,
        editSubsidiariesIndex: index,
        isAddSubsidiaries: false,
        displaySubsidieryDetail: display
      };
    });
    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setEditData(index, display);
      }
    }, 1);
  }

  inviteFleetOpen = () => {
    this.refs.childInviteFleet.toggle({});
  }

  closeInviteFleet = () => {
    this.getNewFleets();
  }

  openInviteFleet = () => {
    //debugger
    // this.refs.childInviteFleet.toggle({});
  }

  inviteAgain = (data) => {
    data.isInviteAgain = true;
    this.refs.childInviteFleet.toggle(data);
  }

  displayFleetDetail = (uuid, type) => {
    this.setState({
      displayBuildMyFleet: true,
      temp_id: uuid,
      addEditVehicleType: type,
      sidebarOpen: false
    });
  }

  closeSideBarAddEditVehicle = () => {
    this.setState({
      displayBuildMyFleet: false,
      sidebarOpen: true
    }, () => {
      this.childNewFleetDetail.current.scrorllToFLeetData();
    });
    this.getNewFleetsById(this.state.temp_id);
  }

  viewRemark = (arr = []) => {
    let { isOpenViewRemarks, remark_history } = this.state;
    if (arr.length > 0) {
      remark_history = arr;
    }
    this.setState({
      isOpenViewRemarks: !isOpenViewRemarks,
      remark_history
    })
  }

  checkProspectiveStatus = (row) => {
    if (row.is_draft) {
      row.custom_status = 'draft';
      return <Badge color="primary" className="offtake-status-table approve-status" style={{ backgroundColor: '#e47927 !important', textTransform: 'capitalize', fontSize: '14px !important' }}>Draft</Badge>
    } else if (row.prospective_status === null) {
      row.custom_status = 'pending';
      return <Badge color="secondary" className="offtake-status-table" style={{ backgroundColor: '#D8ECB4 !important', textTransform: 'capitalize' }}>Pending</Badge>
    } else if (row.prospective_status === 'modification') {
      row.custom_status = 'modification';
      return <Badge color="primary" className="offtake-status-table approve-status" style={{ backgroundColor: '#e47927 !important', textTransform: 'capitalize', fontSize: '14px !important' }}>modification</Badge>;
    } else if (row.prospective_status === 'approve') {
      row.custom_status = 'approve';
      return <Badge color="success" className="offtake-status-table" style={{ backgroundColor: '#51b856 !important', textTransform: 'capitalize' }}>Approved</Badge>;
    } else if (row.prospective_status === 'reject') {
      row.custom_status = 'reject';
      return <Badge color="danger" className="offtake-status-table" style={{ backgroundColor: '#e66c6c !important', textTransform: 'capitalize' }}>Rejected</Badge>
    }
    row.custom_status = 'pending';
    return <Badge color="secondary" className="offtake-status-table" style={{ backgroundColor: '#D8ECB4 !important', textTransform: 'capitalize' }}>Pending</Badge>;
  }

  checkStatus = (row) => {
    if (row.is_draft && row.status !== 'modification') {
      row.custom_status = 'draft';
      return <Badge color="primary" className="offtake-status-table approve-status" style={{ backgroundColor: '#e47927 !important', textTransform: 'capitalize', fontSize: '14px !important' }}>Draft</Badge>
    } else if (row.status === null) {
      row.custom_status = 'pending';
      return <Badge color="secondary" className="offtake-status-table" style={{ backgroundColor: '#D8ECB4 !important', textTransform: 'capitalize' }}>Pending</Badge>
    } else if (row.status === 'modification') {
      row.custom_status = 'modification';
      return <Badge color="primary" className="offtake-status-table approve-status" style={{ backgroundColor: '#e47927 !important', textTransform: 'capitalize', fontSize: '14px !important' }}>modification</Badge>;
    } else if (row.status === 'approve') {
      row.custom_status = 'approve';
      return <Badge color="success" className="offtake-status-table" style={{ backgroundColor: '#51b856 !important', textTransform: 'capitalize' }}>Approved</Badge>;
    } else if (row.status === 'reject') {
      row.custom_status = 'reject';
      return <Badge color="danger" className="offtake-status-table" style={{ backgroundColor: '#e66c6c !important', textTransform: 'capitalize' }}>Rejected</Badge>
    }
    row.custom_status = 'pending';
    return <Badge color="secondary" className="offtake-status-table" style={{ backgroundColor: '#D8ECB4 !important', textTransform: 'capitalize' }}>Pending</Badge>;
  }

  render() {

    const { newFleets, totalPages, totalElement, fleetByIdData,
      showBuildMyFleet, controls, isNoDataFoundNewFleets, isFirstTimeLoadNewFleetsData, displaySubsidieryDetail, displayBuildMyFleet, 
      // isOpen,
      remark_history } = this.state;
    return (
      <>
        {this.state.isLoading && <CustomSpinner></CustomSpinner>}
        {
          // showBuildMyFleet && <FleetRegistration
          //   buildMyFleetClick={this.buildMyFleetClick}
          //   truck={controls.truck} bus={controls.bus}
          //   updateTruckBusData={this.updateTruckBusData}
          //   from="new-fleet-registration"
          //   temp_id={this.state.temp_id}
          // />
          displayBuildMyFleet &&
          <Sidebar
            sidebar={
              <AddEditFleetVehicle
                addEditVehicleType={this.state.addEditVehicleType}
                vehicle_type={this.state.addEditVehicleType}
                closeSideBar={this.closeSideBarAddEditVehicle}
                isAddVehicleDetail={this.state.isAddVehicleDetail}
                uuid={this.state.temp_id}
                isDisplayDetail={true}
                from="new-fleet-reg" />
            }
            open={displayBuildMyFleet}
            sidebarClassName="subsdiaries-sidebar"
            pullRight
            styles={{ sidebar: { background: 'white', height: '100%', width: '40%' } }}
          />
        }
        <div className={showBuildMyFleet ? 'hidden' : ''}>
          {
            this.state.addEditSubsidiaries && this.state.addEditSubsidiaries.length > 0 &&
            <Sidebar
              sidebar={<>
                <div className="drawer-header">
                  {
                    !displaySubsidieryDetail && <span className="drawer-title">{this.state.isAddSubsidiaries ? 'Add' : 'Edit'} Subsidiaries</span>
                  }
                  {
                    displaySubsidieryDetail && <span className="drawer-title">Subsidiaries Details</span>
                  }
                  <img className="cursor-pointer" src="images/close.svg" alt='close' onClick={() => { this.onCloseSidebarSubsidiery(); }} />
                </div>
                <hr style={{ border: 'solid 1px #ced4da' }} />
                <AddEditSubsidiaries
                  editSubsidiariesIndex={this.state.editSubsidiariesIndex}
                  addEditSubsidiaries={Object.assign([], this.state.addEditSubsidiaries)}
                  isAddSubsidiaries={this.state.isAddSubsidiaries}
                  addSubsidiaries={this.addSubsidiaries} ref="childAddEditSubsidiaries"
                  listSubsidiaries={[...this.state.addEditSubsidiaries]}
                  editSubsidiaries={this.editSubsidiaries}
                  removeSubsidiaries={this.removeSubsidiaries}
                  temp_id={this.state.temp_id}
                  from='enroll-new-fleet' />
              </>}
              open={this.state.subsidiaresSidebarOpen}
              sidebarClassName="subsdiaries-sidebar"
              pullRight
              styles={{ sidebar: { background: 'white', height: '90%', top: '60px' } }}
            />
          }

          {
            this.state.sidebarOpen && <div className={this.state.subsidiaresSidebarOpen ? 'hidden' : ''}>
              <Sidebar
                sidebar={<>
                  <div className="drawer-header">
                    <span className="drawer-title">Fleet Details</span>
                    <img className="cursor-pointer" src="images/close.svg" alt='close' onClick={() => { this.onCloseSidebar(); }} />
                  </div>
                  <hr style={{ border: 'solid 1px #ced4da' }} />
                  <NewFleetDetail
                    controls_fleet_registration={this.state.controls}
                    onCloseSidebar={() => this.onCloseSidebar()}
                    fleetByIdData={fleetByIdData}
                    getNewFleets={() => this.getNewFleets()}
                    editSubsidiaries={this.editSubsidiaries}
                    isFleeData={this.state.isFleeData}
                    isListSubsidiaries={this.state.isListSubsidiaries}
                    buildMyFleetClick={this.buildMyFleetClick}
                    subsidiaresSidebarOpen={this.onSetSidebarOpenSubsidiries}
                    addEditSubsidiaries={this.state.addEditSubsidiaries}
                    getSubsidiaries={this.getSubsidiaries}
                    isDataLoding={this.isDataLoding}
                    ref={this.childNewFleetDetail}
                    fleetData={this.state.fleetData}
                    custom_status={this.state.custom_status}
                    displayFleetDetail={this.displayFleetDetail}
                  />
                </>}
                open={this.state.sidebarOpen}
                sidebarClassName="new-fleet-detail-sidebar"
                pullRight
                styles={{ sidebar: { background: 'white', height: '100%', top: '60px' } }}
              />
            </div>
          }

          <Row>
            <Col xl="12" xs="12" md="12">
              <div className="text-align-right" >
                <span className="offtake-title" style={{ float: 'left' }}>New Fleet Registration</span>
                {
                  newFleets && newFleets.length > 0 && <>
                    {this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE && <> <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.inviteFleetOpen() }}>Invite Fleet</Button>&nbsp;&nbsp;</>}
                    {this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE && <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.redirectToEnrollFleet(null) }}>Enroll New fleet</Button>}
                  </>
                }
              </div>
            </Col>
          </Row>
          <br />
          {
            !isNoDataFoundNewFleets && !isFirstTimeLoadNewFleetsData &&
            <>
              <Row className={this.state.isLoading ? 'hidden' : ''}>
                <Col xl="8" md="12" xs="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col>
                          <span className="To-register-a-new-fl">
                            To register a new fleet please click on ‘Enroll New Fleet’ button or you can
            invite new fleet by selecting ‘Invite Fleet’.
                </span>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col>
                          <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.inviteFleetOpen()}>Invite Fleet</Button>&nbsp;&nbsp;
              <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.redirectToEnrollFleet(null) }}>Enroll New fleet</Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          }
          {isFirstTimeLoadNewFleetsData || isNoDataFoundNewFleets ?
            <Row>
              <Col xl="10" md="12" xs="12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            name="q"
                            id="q"
                            value={controls.q.value}
                            placeholder="Search using  fleet name, mobile number or member code"
                            onChange={(e) => this.handleInputChange(e)} />
                          <img src="images/search.svg" className="report-search" alt='search' />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Table className="mb-0 table-responsive" bordered>
                      <thead>
                        <tr style={{ backgroundColor: '#f6f6f6' }}>
                          <th style={{ border: '1px solid #e9ecef' }}>Fleet Name and Code</th>
                          <th style={{ border: '1px solid #e9ecef' }}>Mobile</th>
                          <th style={{ border: '1px solid #e9ecef' }}>Registration Date</th>
                          <th style={{ border: '1px solid #e9ecef' }}>Fleet Type</th>
                          <th style={{ border: '1px solid #e9ecef' }}>Status</th>
                          <th style={{ border: '1px solid #e9ecef' }}>Remarks</th>
                          {this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE &&
                            <th style={{ border: '1px solid #e9ecef' }}>Action</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          newFleets.map((row, i) => (
                            <tr>
                              <td style={{ width: '250px' }} className="text-align-left">
                                <span onClick={() => { this.getNewFleetsById(row.uuid, row.custom_status) }} className="link-blue cursor-pointer" style={{ marginBottom: '5px' }}>
                                  {row.company_name}
                                </span>
                                {
                                  row.member_id &&
                                  <>
                                    <br />
                                    <span>Code: {row.member_id}</span>
                                  </>
                                }
                              </td>
                              <td className="text-align-left">
                                <span>
                                  {row.mobile_number}
                                </span>
                              </td>
                              <td className="text-align-left">
                                <Moment format="DD MMM YYYY">
                                  {row.created_at}
                                </Moment>
                              </td>
                              <td className="text-align-left">
                                {row.is_prospective ? 'Prospective Fleet' : 'New Fleet'}
                              </td>
                              {/* (row.status === 'modifcation' ? <Badge color="primary" className="offtake-status-table approve-status" style={{ backgroundColor: '#e47927 !important', textTransform: 'capitalize', fontSize: '14px !important' }}>Modifcation Needed</Badge> : '') */}
                              {
                                row.is_prospective &&
                                <td className="text-align-left">
                                  {this.checkProspectiveStatus(row)}
                                </td>
                              }
                              {
                                !row.is_prospective &&
                                <td className="text-align-left">
                                  {this.checkStatus(row)}
                                </td>
                              }
                              <td className="text-align-left">
                                {
                                  row.remark_history ?
                                    <span onClick={() => { this.viewRemark(row.remark_history) }} className="link-blue font-weight-bold">
                                      View Remarks
                                </span>
                                    : <span className="no-data-hypen mt-mb-auto ml-2 text-align-center"></span>
                                }
                              </td>
                              {
                                this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE &&
                                row.is_prospective &&
                                <td>
                                  <div className="d-flex-column text-align-left">
                                    {
                                      (row.prospective_status === 'modification' || row.is_draft) ?
                                        <span onClick={() => { this.redirectToEnrollFleet(row.uuid) }} className="link-blue font-weight-bold" style={{ marginBottom: '5px', marginLeft: '0px' }}>
                                          Edit Fleet
                          </span> : (row.prospective_status === 'approve' ? <span onClick={() => { this.redirectToEnrollFleet(row.uuid) }} className="link-blue font-weight-bold" style={{ marginBottom: '5px', marginLeft: '0px' }}>
                                          Enroll As New Fleet
                                </span> : <span className="no-data-hypen mt-mb-auto ml-2 text-align-center"></span>)
                                    }
                                  </div>
                                </td>
                              }
                              {
                                this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE &&
                                !row.is_prospective &&
                                <td>
                                  <div className="d-flex-column text-align-left">
                                    {
                                      row.is_draft && this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE ? <>
                                        <span onClick={() => { this.redirectToEnrollFleet(row.uuid) }} className="link-blue font-weight-bold" style={{ marginBottom: '5px', marginLeft: '0px' }}>
                                          Edit Fleet
                            </span>
                                        <span onClick={() => { this.inviteAgain(row) }} className="link-blue font-weight-bold" style={{ marginBottom: '5px', marginLeft: '0px' }}>
                                          {row.invited ? 'Invite Again' : 'Invite Fleet'}
                                        </span>
                                      </> : <span className="no-data-hypen mt-mb-auto ml-2 text-align-center"></span>
                                    }
                                  </div>
                                </td>
                              }
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                    {totalElement > 10 && <Pagination
                      margin={2}
                      page={this.state.page}
                      count={totalPages}
                      pageSize={this.state.pageSize}
                      totalRecords={newFleets}
                      onPageChange={this.handlePageChange}
                    />}
                    {totalElement <= 0 &&
                      <div className="no-data">
                        Currently, there is no new fleets to display
                    </div>
                    }
                  </CardBody>
                </Card>
              </Col>
            </Row>
            : ""}

          <Modal isOpen={this.state.isOpenViewRemarks} className="modal-md modal-lg custom-confirm-modal modal-sm" style={{ maxWidth: '500px' }} backdrop={this.backdrop ? 'static' : 'nostatic'}>
            <div className="d-flex-column">
              <div className="confirm-modal-title-wrapp">
                <span className="confirm-modal-title">Remarks</span>
                <FontAwesomeIcon className="pull-right cursor-pointer" onClick={() => this.viewRemark([])} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
              </div>
            </div>
            <ModalBody classNam="d-flex-column">
              <Row>
                {
                  remark_history.map((row, i) => (
                    <Col xl="12" md="12" xs="12" className="mb-1">
                      <Card style={{ marginTop: '5px' }}>
                        <CardBody className="d-flex-column">
                          <span style={{ color: '#9e9e9e', fontSize: '12px', marginBottom: '5px' }}>
                            <Moment format="DD MMM YYYY">
                              {row.remark_date}
                            </Moment>
                          </span>
                          <span>
                            {row.remark}
                          </span>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                }
                <Col>
                </Col>
              </Row>
            </ModalBody>
            {/* <Col xl="12" xs="12" md="12" className="text-align-right mt-3 mb-3" >
              <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning"
                onClick={() => this.submitExpensincurred()}>Submit</Button>
            </Col> */}
          </Modal>


          <InviteFleet ref="childInviteFleet" closeModal={this.closeInviteFleet} />
        </div>
      </>
    );
  }
}

export default NewFleetRegistration;